<template>
  <FaqList :items="items" />
</template>

<script>
import FaqList from '@/components/Faq/FaqList.vue'

export default {
  name: 'FaqGeneral',
  components: {
    FaqList,
  },

  computed: {
    items() {
      return [...Array(5)].map((_, index) => ({
        question: this.$t(`item${index + 1}.question`),
        answer: this.$t(`item${index + 1}.answer`),
      }))
    },
  },
}
</script>

<i18n src="@/locales/faq-general.json" />
